let loaderCountOnPg2Search = {
    count: 0
}

export default loaderCountOnPg2Search;